// import aa from 'search-insights';

// aa('init', {
//     appId: window.config.algolia.app_id,
//     apiKey: window.config.algolia.search_api_key,
// });

const LAST_VIEWED_KEY = 'last_viewed_products';

const getLastViewed = () => {
    const lastViewed = JSON.parse(localStorage.getItem(LAST_VIEWED_KEY) || JSON.stringify([]));
    return lastViewed.slice(-10);
};

const setLastViewed = (lastViewed) =>
    localStorage.setItem(LAST_VIEWED_KEY, JSON.stringify(lastViewed));

const removeLastViewed = (productId) => {
    const lastViewed = getLastViewed();

    localStorage.setItem(
        LAST_VIEWED_KEY,
        JSON.stringify(lastViewed.filter((el) => el !== productId))
    );
};

const getLastViewedUrl = () =>
    getLastViewed()
        .map((el) => `products[]=${el}`)
        .join('&');

const removeLastViewedListener = () => {
    const removeLastViewedElements = [
        ...document.querySelectorAll('.js-remove-last-viewed'),
    ].filter((el) => !el.dataset.lastViewedInitialized);

    removeLastViewedElements.forEach((el) => {
        el.addEventListener('click', () => {
            removeLastViewed(el.dataset.productId);
        });

        el.dataset.lastViewedInitialized = true;
    });
};

const updateLastViewedRemoteContent = async () => {
    const url = getLastViewedUrl();

    const lastViewedElementsToUpdate = [...document.querySelectorAll('.js-last-viewed')].filter(
        (el) => !el.dataset.lastViewedInitialized
    );

    lastViewedElementsToUpdate.forEach((el) => {
        el.dataset.remoteContent = `/ajax/favorites?view=${el.dataset.view}${url ? `&${url}` : ''}`;
        el.dataset.lastViewedInitialized = true;
    });
};

export const lastViewedListener = () => {
    const lastViewed = getLastViewed();
    const productId = window.PRODUCT_ID;

    if (productId) {
        setLastViewed([...new Set([...lastViewed, productId])]);
    }

    // updateLastViewedRemoteContent();

    ['DOMContentLoaded', 'RemoteContentLoaded'].forEach((ev) => {
        window.addEventListener(ev, () => {
            removeLastViewedListener();

            updateLastViewedRemoteContent();
        });
    });
};
